// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 17.4998V6.4998L5 6.5L5 17.5L9 17.4998Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.0004 22.7095L11 18.2099V5.7896L19.0004 1.29004L19.0004 22.7095Z"}}]};

const SoundMuteFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sound-mute-filled',
    ref,
    icon: element,
  },
));

SoundMuteFilledIcon.displayName = 'SoundMuteFilledIcon';

export default SoundMuteFilledIcon;
